var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},_vm._l((200),function(i){return _c('div',[_vm._v("联系我们"+_vm._s(i))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }